/**
 * Wishlist facade: paint badge/button state from localStorage.
 * Full CSS/JS load on first heart or drawer click, then replay that click.
 */
(() => {
  const dialog = document.getElementById("wishlist-drawer");
  if (!dialog) return;
  if (customElements.get("wishlist-component")) return;

  const loader = window.BoltFeatureLoader;
  const assets = window.BoltAssets || {};
  const cssHref = assets.wishlistCss || dialog.dataset.facadeCss;
  const jsSrc = assets.wishlist || dialog.dataset.facadeJs;
  if (!loader || !cssHref || !jsSrc) return;

  const STORAGE_KEY = "ks-wishlist";
  const CLICK_SELECTOR = ".wishlist-btn, [data-open-dialog='wishlist-drawer']";

  let hydratePromise = null;
  let pendingTrigger = null;

  const readList = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };

  const paint = () => {
    const items = readList();
    const count = String(items.length);

    document.querySelectorAll("[data-badge='wishlist']").forEach((elem) => {
      elem.textContent = count;
      elem.setAttribute("data-count", count);
    });
    dialog.setAttribute("data-wishlist-count", count);

    const handles = new Set(items.map((item) => item.handle));
    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
      const active = handles.has(btn.dataset.productHandle);
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      const label = active
        ? btn.dataset.textRemove || btn.getAttribute("aria-label")
        : btn.dataset.textAdd || btn.getAttribute("aria-label");
      if (label) btn.setAttribute("aria-label", label);
    });
  };

  const hydrate = () => {
    if (customElements.get("wishlist-component")) return Promise.resolve();
    if (hydratePromise) return hydratePromise;

    hydratePromise = Promise.all([
      loader.loadStylesheet(cssHref, "bolt-wishlist-css"),
      loader.loadScript(jsSrc, "bolt-wishlist-js"),
    ])
      .then(() => customElements.whenDefined("wishlist-component"))
      .then(() => {
        dialog.dataset.facadeBound = "true";
        document.removeEventListener("click", onFirstClick, true);
      })
      .catch((error) => {
        hydratePromise = null;
        dialog.dataset.facadeBound = "false";
        console.error("Wishlist facade failed to load", error);
        throw error;
      });

    return hydratePromise;
  };

  const onFirstClick = async (event) => {
    const trigger = event.target.closest(CLICK_SELECTOR);
    if (!trigger) return;
    if (customElements.get("wishlist-component")) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    pendingTrigger = trigger;

    try {
      await hydrate();
      const replay = pendingTrigger;
      pendingTrigger = null;
      replay?.click();
    } catch (error) {
      pendingTrigger = null;
    }
  };

  paint();
  document.addEventListener("click", onFirstClick, true);
})();
